<template>
    <p class="conf-template small-text">{{ template }}</p>
</template>

<script>

import axios from 'axios';

export default {
    name: 'ConfigPage',
    props: ['prjnum', 'keynum', 'conf'],
    data(){
        return {
            template: ''
        }
    },
    methods: {
        getConfig() {
            axios.get(this.url)
            .then((response) => {
                console.log(response.data);
                this.template = response.data;
            })
            .catch(error => {
                console.log(error.response.status, error.response.statusText);
                this.template = "Configuration template could not be generated";
            });
        },
    },
    computed: {
        url() {
            return '/api/v1/project/' + this.prjnum + '/key/' + this.keynum + '/conf/' + this.conf;
        }
    },
    created() {
        this.getConfig();
    }
}  
</script>

<style scoped>

.conf-template {
    font-family: monospace;
    margin: 1rem;
    white-space: pre-wrap;
}

@media screen and (max-width: 500px) {
    .conf-template {
        overflow-wrap: anywhere;
    }
}

</style>